export default "__VITE_ASSET__Blkw7k8q__"